<template>
  <router-link
    class="logo-container"
    to="/"
  >
    <img
      src="/dist/logos/website/footer-logo.svg"
      class="logo"
      :title="`${siteName} Logo`"
    >
  </router-link>
</template>
<script>
export default {
  computed: {
    siteName() {
      return this.$store.state.registry.getSiteSetting('title')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

.logo {
  width: var(--main-logo-width);
  @include media-breakpoint-up(sm) {
    width: var(--main-logo-width-sm);
  }
  @include media-breakpoint-up(md) {
    width: var(--main-logo-width-md);
  }
  @include media-breakpoint-up(lg) {
    width: var(--main-logo-width-lg);
  }
}
</style>
